import { render, staticRenderFns } from "./InputCheckbox.vue?vue&type=template&id=ef055e0a&scoped=true"
import script from "./InputCheckbox.vue?vue&type=script&lang=js"
export * from "./InputCheckbox.vue?vue&type=script&lang=js"
import style0 from "./InputCheckbox.vue?vue&type=style&index=0&id=ef055e0a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef055e0a",
  null
  
)

export default component.exports